import { render, staticRenderFns } from "./orderRecordList.vue?vue&type=template&id=55ff40e7&"
import script from "./orderRecordList.vue?vue&type=script&lang=js&"
export * from "./orderRecordList.vue?vue&type=script&lang=js&"
import style0 from "./orderRecordList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports